import { createClient } from '@sanity/client';

// `useCdn` is enabled by default; set SANITY_DISABLE_CDN=true during builds
// so ISR pages fetch fresh content instead of hitting the cached Sanity CDN.
const sanityClient = createClient({
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
  dataset: process.env.NEXT_PUBLIC_SANITY_DATASET,
  apiVersion: process.env.NEXT_PUBLIC_SANITY_API_VERSION,
  useCdn: process.env.SANITY_DISABLE_CDN !== 'true',
});

export { sanityClient };
